import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { ExpressDeliveryHowItWorks } from './ExpressDeliveryHowItWorks';

const ExpressDeliveryDetails = ({
  fulfillment, channel, covidEnabled, quantity, pricing, bodfsMinimumThreshold
}) => {
  const showMinimumThresholdMessage = (quantity * pricing?.value < bodfsMinimumThreshold);
  return (
    <>
      {covidEnabled && (
        <span>Schedule delivery at checkout</span>
      )}
      {!covidEnabled && fulfillment.deliveryTimeline && (
        <span>
          <span>Get it scheduled for delivery as soon as</span>
          <span className="delivery__timeline u__bold">
            {` ${fulfillment.deliveryTimeline.toLowerCase()}`}
          </span>
        </span>
      )}
      {!covidEnabled && !fulfillment.deliveryTimeline && (
        <span>Schedule express delivery at your convenience</span>
      )}
      <div>
        <Tooltip
          channel={channel}
          closeButton
          placement="bottom"
          content={<ExpressDeliveryHowItWorks />}
          interactive
        >
          <span className="delivery__tooltip-text">How It Works</span>
        </Tooltip>
      </div>
      {showMinimumThresholdMessage && (
        <div className="alert-inline alert-inline--warning inventory--warning">
          <span>There&apos;s a ${bodfsMinimumThreshold} minimum purchase for Scheduled Delivery.</span>
        </div>
      )}
    </>
  );
};

ExpressDeliveryDetails.propTypes = {
  fulfillment: PropTypes.objectOf(PropTypes.any).isRequired,
  channel: PropTypes.string,
  covidEnabled: PropTypes.bool,
  quantity: PropTypes.number,
  pricing: PropTypes.shape({
    value: PropTypes.number
  }).isRequired,
  bodfsMinimumThreshold: PropTypes.number
};
ExpressDeliveryDetails.defaultProps = {
  channel: 'desktop',
  covidEnabled: false,
  quantity: 1,
  bodfsMinimumThreshold: null
};

export { ExpressDeliveryDetails };
